const EnergyCommunityParticipationModel = Object.freeze({
    STATIC: 'static',
    DYNAMIC: 'dynamic',
    tryFrom(value) {
        return Object.keys(this).find((key) => this[key] === value);
    },
    getDescription(value) {
        switch (value) {
            case this.STATIC:
                return 'Statisch';
            case this.DYNAMIC:
                return 'Dynamisch';
            default:
                return null;
        }
    },
});

export default EnergyCommunityParticipationModel;
